import DashboardStatus from "./DashboardStatus";

export default DashboardStatus;